var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Card = function (_a) {
    var className = _a.className, wrapperClassName = _a.wrapperClassName, children = _a.children, noPadding = _a.noPadding, spotlights = _a.spotlights, largeSpotlights = _a.largeSpotlights;
    return (_jsxs("div", __assign({ className: "grid rounded-[10px] overflow-clip ".concat(wrapperClassName !== null && wrapperClassName !== void 0 ? wrapperClassName : "") }, { children: [_jsxs("div", __assign({ className: "overlap-grid w-full h-full overflow-hidden relative z-[-50]" }, { children: [spotlights.map(function (light, idx) {
                        return (_jsx("div", { className: "absolute ".concat(light, " bg-radial-spotlight w-[600px] h-[600px]") }, idx));
                    }), largeSpotlights != null &&
                        largeSpotlights.map(function (light, idx) {
                            return (_jsx("div", { className: "absolute ".concat(light, " bg-radial-spotlight-lg w-[600px] h-[600px]") }, idx));
                        })] })), _jsx("div", __assign({ className: "".concat(noPadding ? "" : "p-[16px]", " ").concat(className !== null && className !== void 0 ? className : "", " overlap-grid w-full") }, { children: children }))] })));
};
